import MovieFilterOutlinedIcon from "@mui/icons-material/MovieFilterOutlined";
import { useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import PiButton from "../../components/PiButton";
import { addNewTake } from "../../app/slices/TrainingSlice";
import useShortcut, { ShortCuts } from "../../hooks/UseShortcutsHook";
import "../training_timeline/TrainingTimeline.css";
import "./Timeline3D.css";
import Timeline3DTakesList from "./Timeline3DTakesList";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";
import { CreateTransition } from "../../models/interactions/Transition";
import { useTimelineCopyPaste } from "../training_timeline/useTimelineCopyPaste";
import { TimelineClipboardContext } from "../training_timeline/CopyPasteContext";

export default function Timeline3D() {
  const dispatch = useDispatch();
  const scrollerRef = useRef<HTMLDivElement>(null);
  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const { getNewKey } = useTrainingLocalization();
  const {
    handleCopy,
    handleCut,
    handlePaste,
    handlePasteIntoSlot,
    handleDuplicate,
  } = useTimelineCopyPaste();

  const onAddTakeClick = async () => {
    dispatch(addNewTake({ transition: CreateTransition(getNewKey()) }));

    await delay(100);

    // scroll to bottom of scroller
    if (scrollerRef.current)
      scrollerRef.current.scrollTop = scrollerRef.current?.scrollHeight;
  };

  useShortcut(ShortCuts.Copy, handleCopy);
  useShortcut(ShortCuts.Cut, handleCut);
  useShortcut(ShortCuts.Paste, handlePaste);
  useShortcut(ShortCuts.Duplicate, handleDuplicate);

  const clipboardActions = useMemo(
    () => ({ handleCopy, handleCut, handlePaste, handlePasteIntoSlot }),
    [handleCopy, handleCut, handlePaste, handlePasteIntoSlot]
  );

  const addTakeButton = (
    <div className="px-[18px] h-[40px]">
      <PiButton variant={"piBlue"} onClick={onAddTakeClick}>
        <div
          className={"h-full flex justify-center mx-auto justify-items-center"}
        >
          <div className={"flex gap-[8px] my-auto text-[24px]"}>
            <MovieFilterOutlinedIcon className={""} fontSize={"inherit"} />
            <div className={"text-[14px] my-auto"}>Add Take</div>
          </div>
        </div>
      </PiButton>
    </div>
  );

  return (
    <TimelineClipboardContext.Provider value={clipboardActions}>
      <div className="h-full flex flex-col gap-y-[10px]">
        <Timeline3DTakesList />
        {addTakeButton}
      </div>
    </TimelineClipboardContext.Provider>
  );
}
